module.exports = __webpack_public_path__ + "static/img/23.66337ad7.png";